<template>
  <div class="na-menu-item-content">
    <Icon v-if="menuItem.icon && !menuItem.hideIcon"
          :icon="menuItem.icon"
          :pack="menuItem.iconPack || 'fal'"
          fixed-width class="mr-3"
    />
    <div class="na-menu-item-title"
         :class="{ 'justify-content-center': align === 'center' }"
         v-if="!menuItem.hideTitle"
    >
      <span v-html="menuItem.title"/>
      <span
          v-if="menuItem.count"
          class="na-menu-item-count"
          :class="{ 'is-dot': menuItem.count === true }"
          aria-label="Unread"
      >
        <template v-if="menuItem.count !== true">{{ menuItem.count }}</template>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MenuItemContent',
  data() {
    return {};
  },
  props: {
    align: {
      type: String,
    },
    menuItem: {
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
.na-menu-item-content {
  align-items: center;
  display: flex;
  flex: 1;
  padding: 2.5px 0;
  position: relative;

  .icon {

  }

  .na-menu-item-title {
    align-items: center;
    display: flex;
    flex: 1;
    justify-content: space-between;

    &.justify-content-center {
      justify-content: center;
    }

    .na-menu-item-count {
      align-items: center;
      background: var(--brand-primary-500, #14b8a6);
      border-radius: 999px;
      color: white;
      display: inline-flex;
      flex: none;
      font-size: 0.65rem;
      font-weight: 700;
      justify-content: center;
      line-height: 1;
      margin-left: 0.5rem;
      min-height: 1.15rem;
      min-width: 1.15rem;
      padding: 0.2rem 0.35rem;

      &.is-dot {
        height: 0.65rem;
        min-height: 0.65rem;
        min-width: 0.65rem;
        padding: 0;
        width: 0.65rem;
      }
    }
  }
}
</style>
